/*
 * Назначение: реакция на ширину экрана в компонентах админки.
 * Функционал: useMediaQuery — подписка на CSS-медиазапрос (значение известно
 * сразу при первом рендере, без «мигания» десктопной раскладки на телефоне);
 * готовые запросы совпадают с брейкпоинтами Tailwind (md = 768px, lg = 1024px).
 */

import { useEffect, useState } from "react";

/** Телефон: меню выезжает поверх страницы (как `md:` в Tailwind). */
export const MQ_DESKTOP_NAV = "(min-width: 768px)";
/** Три колонки на странице диалогов (как `lg:` в Tailwind). */
export const MQ_WIDE = "(min-width: 1024px)";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window === "undefined" ? true : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
